import { LoadingButton } from '@mui/lab';
import { Avatar, Button, Grid, Paper, Typography } from '@mui/material';
import { Box } from '@mui/system';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import CopyrightTemplate from '../../../widgets/template/Copyright';
import PasswordField from '../login/components/PasswordField';

const RecoverModule = () => {
  let history = useHistory();
  const [pass, setPass] = React.useState({
    password: '',
    confirm: '',
  });

  const [showPassword, setShowPassword] = React.useState(false);
  const _handleSetDataLogin = (prop) => (event) => {
    setPass({ ...pass, [prop]: event.target.value });
  };

  return (
    <center>
      <Box
        sx={{
          width: '30%',
        }}
      >
        <Avatar
          alt="On Pass"
          src="./img/logoon.png"
          sx={{ width: 150, height: 150, padding: '20px' }}
        />
        <Typography component="h1" variant="h3" sx={{ fontWeight: '700' }}>
          ON PASS
        </Typography>
        <Typography sx={{ mt: 2, mb: 2 }} component="h1" variant="h5">
          Recuperar Contraseña
        </Typography>
        <Paper elevation={5} sx={{ p: 3 }}>
          <Grid container spacing={1}>
            <Grid item md={12}>
              <PasswordField
                value={pass.password}
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                showPassword={showPassword}
                onChange={_handleSetDataLogin('password')}
              />
            </Grid>
            <Grid item md={12}>
              <PasswordField
                value={pass.confirm}
                label="Confirmar contraseña"
                onClick={() => {
                  setShowPassword(!showPassword);
                }}
                showPassword={showPassword}
                onChange={_handleSetDataLogin('confirm')}
              />
            </Grid>
            <Grid item md={12}>
              <LoadingButton
                fullWidth
                variant="contained"
                sx={{ mt: 3 }}
                onClick={async () => {
                  // setLoading(true)
                  // const res = await resetPassService(pass.password, pass.confirm)
                  // if (res.status >= 200 && res.status <= 203) {
                  //     setLoading(false)
                  // }
                }}
              >
                ENVIAR
              </LoadingButton>
            </Grid>
          </Grid>
        </Paper>
        <Button
          sx={{
            mt: 3,
            mb: 3,
          }}
          onClick={() => {
            history.push('/');
          }}
        >
          Volver al Inicio de Sesión
        </Button>
        <CopyrightTemplate sx={{ mt: 5 }} />
      </Box>
    </center>
  );
};

export default RecoverModule;
